import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? `${x.loc?.slice(-1)[0] || ""}: ${x.msg}` : JSON.stringify(x))).join(" ");
  return String(d);
}

export function money(v, cur) {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: cur || "USD", maximumFractionDigits: 2 }).format(v || 0);
  } catch {
    return `${cur} ${Number(v || 0).toFixed(2)}`;
  }
}

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export async function openPdf(url, filename, download = false) {
  const win = download ? null : window.open("", "_blank");
  try {
    const r = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    setTimeout(() => URL.revokeObjectURL(href), 60000);
    if (win) {
      win.location.href = href;
    } else {
      const a = document.createElement("a");
      a.href = href;
      a.download = filename;
      a.click();
    }
  } catch (e) {
    if (win) win.close();
    toast.error(errMsg(e));
  }
}

export function useLoad(url, params) {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const load = useCallback(async () => {
    if (!url) return;
    try {
      const r = await api.get(url, { params: JSON.parse(key) });
      setData(r.data);
    } catch (e) {
      toast.error(errMsg(e));
      setData([]);
    }
  }, [url, key]);
  useEffect(() => {
    load();
  }, [load]);
  return [data, load];
}
